import { ChangeDetectorRef, Component } from '@angular/core';
import { InventoryCategoryService } from '../../services/inventory-category.service';
import { InventoryCategory } from '@contracts/interfaces/inventory-category';
import { ConnectionService } from 'src/app/services/connection.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { Router } from '@angular/router';

export interface DialogData {

}

@Component({
  selector: 'app-inventory-categories-component',
  templateUrl: 'inventory-categories.component.html',
  styleUrls: ['./inventory-categories.component.scss', './categories.scss', 'ap-table.scss']
})
export class InventoryCategoriesComponent {

  public loading = true;
  public deletingCategoryID: number = null;
  public deleteCategoryError = '';

  public searchQuery: string = null;
  public categorys: InventoryCategory[] = [];
  public trackThumbChanges: number[] = [];
  
  private categoryStats: any[] = [];

  constructor(
    public inventoryCategoryService: InventoryCategoryService,
    private inventoryService: InventoryService,
    private connectionService: ConnectionService,
    private cdr: ChangeDetectorRef,
    private router: Router
    ) {

    }

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;

    this.inventoryService.getInventoryListCompiled().subscribe((result: any) => {
      this.categorys = result.filter(category => category.id != null);
      this.loading = false;
    });

    this.inventoryService.getInventoryStats().subscribe((r:any) => {
      this.categoryStats = r;
      this.cdr.detectChanges();
    });
  }

  getCategoryPlaceholder() {
    return `background-image: url('${this.connectionService.address}/inventory-category-pictures/placeholder.jpg');`;
  }

  getThumbImage(category: InventoryCategory, index: number) {
    let hasUpdated = "";
    if (this.trackThumbChanges[index] != undefined) {
      hasUpdated = "?t=" + this.trackThumbChanges;
    }

    return this.connectionService.address + "/inventory-category-pictures/" + category.id + "-dp.jpg" + hasUpdated;
  }
  
  getStats(category: InventoryCategory) {
    if (this.categoryStats.length > 0) {
      for (let c of this.categoryStats) {
        if (c.id == category.id) {
          return c;
        }
      }
    }

    return {
      needsAttention: 0,
      unlisted: 0
    }
  }

  newCategory() {
    this.inventoryCategoryService.newCategoryDialog((r) => {
      this.load();
    });
  }

  selectCategory(category: InventoryCategory) {
    this.router.navigate(['/inventory/c', category.id]);
  }

  deleteCategory(category: InventoryCategory) {
    if (this.deletingCategoryID !== null) return;
    if (!window.confirm(`Delete category "${category.nicename}"? It will be removed from the category list. Its items and history will be kept.`)) return;

    this.deletingCategoryID = category.id;
    this.deleteCategoryError = '';
    this.inventoryCategoryService.archive(category.id).subscribe({
      next: deleted => {
        this.deletingCategoryID = null;
        if (deleted === true) {
          this.load();
        } else {
          this.deleteCategoryError = 'Could not delete the category. Refresh and try again.';
        }
      },
      error: () => {
        this.deletingCategoryID = null;
        this.deleteCategoryError = 'Could not delete the category. Refresh and try again.';
      }
    });
  }

}
